import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

type Props = {
  open: boolean;
  entityName?: string | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /** What is being withdrawn, used in the title and text. Defaults to the VP sign off. */
  subject?: "sign off" | "operational readiness";
};

// Market Access can pull a sent sign off (or operational readiness) back to draft to
// reconfigure it. Withdrawing clears every signature so signing starts fresh once it is sent
// again. Confirm only, no cause required (unlike a VP rejection).
export const WithdrawSignOffDialog: FC<Props> = ({
  open,
  entityName,
  saving,
  onClose,
  onConfirm,
  subject = "sign off"
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>Withdraw {subject}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Withdrawing returns the {subject} for {entityName || "this entity"} to
        draft and clears every signature collected so far. You can reconfigure
        the signatories and send it again.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={saving}>
        Cancel
      </Button>
      <Button
        variant="contained"
        color="warning"
        disabled={saving}
        loading={saving}
        onClick={onConfirm}
      >
        Withdraw to draft
      </Button>
    </DialogActions>
  </Dialog>
);
